module.exports = __webpack_public_path__ + "img/1200_380_my_channel.6c8e44ae.png";